import React from "react";
import toast from "../../components/base/Toast";
import PaymentFormFields from "./PaymentFormFields";

// Components
import DeleteButton from "../../components/base/DeleteButton";
import CancelButton from "../../components/base/CancelButton";
import SaveButton from "../../components/base/SaveButton";
import PageTitle from "../../components/base/PageTitle";
import Form from "../../components/base/Form";

//configs
import { endpoints } from "../../configs";

// API call
import { apiClient } from "../../apiClient";

//Helper
import { toString } from "../../lib/helper";
import { isBadRequest } from "../../common/http";

export default class UpdatePaymentForm extends React.Component {
  constructor(props) {
    super(props);
    // Set the initial input values
    this.state = {
      paymentDetails: [],
      loading: false
    };
  }

  componentDidMount = () => {
    this._getPaymentDetails();
  };

  _submit = values => {
    if (this._validateFields(values) === false) {
      return;
    }

    // Save customer data form
    this._updatePayment(this._toArray(values));
  };

  // Validate Fields
  _validateFields(values) {
    let success = true;

    // define Customer constants
    const name = values.name;

    if (!name) {
      success = false;
    }

    return success;
  }

  // To Array
  _toArray(values) {
    values.name = toString(values.name);
    values.description = toString(values.description);
    values.amount = toString(values.amount);
    values.date = toString(values.date);
    return values;
  }

  // Customer update API Call
  _updatePayment(data) {
    return apiClient
      .put(`${endpoints().paymentAPI}/${this.props.match.params.id}`, data)
      .then(() => {
        window.location.replace("/payment");
      })
      .catch(error => {
        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          toast.error(error.response.data.message);
          console.error(errorMessage);
        }
      });
  }

  // Customer delete api call
  handleDelete = () => {
    return apiClient
      .delete(`${endpoints().paymentAPI}/${this.props.match.params.id}`)
      .then(() => {
        window.location.replace("/payment");
      })
      .catch(error => {
        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          toast.error(error.response.data.message);
          console.error(errorMessage);
        }
      });
  };

  // Customer details api call by id
  _getPaymentDetails = () => {
    return apiClient
      .get(`${endpoints().paymentAPI}/${this.props.match.params.id}`)
      .then(response => {
        this.setState({ paymentDetails: response.data, loading: true });
      })
      .catch(error => {
        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          console.error(errorMessage);
        }
      });
  };

  render() {
    if (!this.state.loading) {
      return "";
    }

    const { name, date, description, amount } = this.state.paymentDetails;

    const initialValues = { name, date, description, amount };
    return (
      <React.Fragment>
        <PageTitle label={name} />
        <Form
          initialValues={initialValues}
          onSubmit={values => {
            this._submit(values);
          }}
        >
          <PaymentFormFields />
          <div className="mb-4">
            <DeleteButton
              label={"Delete Payment"}
              onClick={this.handleDelete}
            />
            <div style={{ float: "right" }}>
              <CancelButton onClick={() => this.props.history.goBack()} />
              <SaveButton />
            </div>
          </div>
        </Form>
      </React.Fragment>
    );
  }
}
